var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20C4.32541 17.7892 6.468 16 11 16C15.532 16 17.6746 17.7892 19 20M14.7 8.6C14.7 10.5882 13.0882 12.2 11.1 12.2C9.11178 12.2 7.5 10.5882 7.5 8.6C7.5 6.61177 9.11178 5 11.1 5C13.0882 5 14.7 6.61177 14.7 8.6Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2L19.5 7",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.5L17 4.5",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user_plus.0f468c79fc8b064d00d67e240bfdd3e1.svg";
export { ForwardRef as ReactComponent };